import './App.css';
import BlogList from './components/BlogList';

function App() {
  return (
    <div className="App">
      <BlogList />
    </div>
  );
}

export default App;
